import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import MainNav from './MainNav';
import Footer from './Footer';
import PromoBar from './PromoBar';
import MobileBottomNav from './MobileBottomNav';

// Pages that should be shown WITHOUT site header/footer (full-screen editors, etc.)
const CHROMELESS_PATHS = ['/design/editor', '/pay'];

export default function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = useLocation().pathname;

  // Check if current route should hide site chrome
  const isChromeless = CHROMELESS_PATHS.some((path) => pathname.startsWith(path));

  if (isChromeless) {
    // Render children without any site header/footer — full-screen mode
    return <>{children}</>;
  }

  // Normal pages with full site chrome. On mobile, Footer is hidden via CSS
  // (native apps don't have multi-column footers) and MobileBottomNav is
  // shown. On tablet+ the classic layout is preserved.
  return (
    <>
      <PromoBar />
      <Header />
      <MainNav />
      <main className="site-main">{children}</main>
      <Footer />
      <MobileBottomNav />
    </>
  );
}
